import { FC } from 'react';

import { AccountPageProps } from '../account';
import { AccountPlansCreate } from './plans/create';
import { AccountPlansSupreme } from './plans/supreme';

type Props = AccountPageProps & {
    isCreate?: boolean
};

export const AccountPlans: FC<Props> = ({ isCreate, ...props }) => isCreate
    ? <AccountPlansCreate {...props} />
    : <AccountPlansSupreme {...props} />;
